<template>
  <div class="ym-page">
    <!-- 显示nothing -->
    <div class="data-list nothing"
         v-if="hasInfo === 2">
      <img src="../chainData/img/nothing.png"
           alt="">
      <span class="nothing-text"
            style="margin-left: -18px;">暂无数据</span>
    </div>
    <!-- 显示loading -->
    <div class="data-list nothing"
         style="margin-top:300px;"
         v-if="hasInfo === 1">
      <i class="el-icon-loading"
         style="font-size:50px;"></i>
      <span class="nothing-text"
            style="margin-left:2px;">加载中</span>
    </div>
    <!-- 区块信息 -->
    <block-detail :datas="searchValue"
                  v-on:block-say="getFromBlock"></block-detail>
  </div>
</template>

<script>
import BlockDetail from './component/blockDetail.vue'
export default {
  components: {
    BlockDetail
  },
  name: 'blockDetails',
  data() {
    return {
      hasInfo: 1, // 默认1:显示loading/2:显示暂无数据/3:显示数据
      searchValue: {
        shard: null, // 分片名（默认全部）
        searchKey: '' // 高度
      }
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.shardName) {
      this.searchValue.shard = this.$route.query.shardName
    }
    if (this.$route.query.searchKey) {
      this.searchValue.searchKey = this.$route.query.searchKey
    }
  },
  methods: {
    getFromBlock(value) {
      if (value !== this.hasInfo) {
        this.hasInfo = value
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ym-page {
  .data-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    &.nothing {
      padding-bottom: 20px;
      margin: 200px auto;
      font-size: 14px;
      img {
        width: 180px;
        height: 181px;
      }
      .nothing-text {
        margin-top: 10px;
        color: #888888;
      }
    }
  }
}
</style>
